import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const StyledBreadCrumbs = styled.nav`
  margin-bottom: 32px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    margin-bottom: 24px;
  }
  a {
    font-size: 12px;
    line-height: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.default.color.text.dark};
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    text-transform: uppercase;

    &:after {
      color: ${({ theme }) => theme.default.color.text.dark};
      font-size: 12px;
      content: "\\5C";
      margin-left: 16px;
      margin-right: 16px;
      font-weight: 800;
      text-decoration: initial;
    }
    &:last-child {
      color: ${({ theme }) => theme.default.color.text.dark};
      &:after {
        content: "";
      }
    }
  }
`;
